<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span class="glyphicon glyphicon-th-list"></span> örtliche Prüfungen</button>

<dx-popup class="popup"
          style="display: inline-block;"
          [showTitle]="true"
          title="Örtliche Prüfungen"
          [dragEnabled]="false"
          [height]="'70%'"
          [width]="'70%'"
          [hideOnOutsideClick]="false"
          (onHidden)="onHiddenOertPrfPopup($event)"
          [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView
                    *ngIf="!loading"
                    id="scrollview"
                    [scrollByContent]="true"
                    [scrollByThumb]="true"
                    [showScrollbar]="'onHover'"
                    reachBottomText="Updating...">
      <dx-accordion #accordion
                    [dataSource]="einrichtungen"
                    [collapsible]="true"
                    [multiple]="false"
                    [animationDuration]="300">
        <div *dxTemplate="let e of 'title'" [ngClass]="{ rowRed: !isAllOpOk(e), rowgreen: isAllOpOk(e) }">
          <strong>{{e.name}}&nbsp;&nbsp;</strong><small>{{e.adresse}}</small>
        </div>
        <div *dxTemplate="let e of 'item'">
          <div style="margin-top:10px;">
            <div class="row">
              <div class="col-md-12 text-right">
                <button (click)="onAddOertPrfClick($event, e)" class="btn btn-sm btn-success">örtliche Prüfung Anlegen</button>
              </div>
            </div>
            <div style="margin-top:20px;">
              <div *ngIf="e.oertPruef.length" class="col-md-12" style="padding:10px; background-color:rgba(233, 233, 233, 0.60)">
                <div style="padding:3px; margin-left:0!important; margin-right:0!important;" *ngFor="let op of e.oertPruef; let odd=odd; let even=even;" class="row" [ngClass]="{ rowRed: !isAllAuflagenOk(op), rowgreen: isAllAuflagenOk(op)  }">
                  <div class="col-md-12">
                    <div class="col-md-1 col-sm-1">
                      <button title="Öffnen" (click)="onOpenAuflagenClick(op)" class="btn btn-xs"><i class="glyphicon glyphicon-play"></i></button>
                    </div>
                    <div class="col-md-2 col-sm-2">
                      <strong>
                        {{op.pruefungstermin | date}}:
                      </strong>
                    </div>
                    <div class="col-md-9 col-sm-9">
                      <span>
                        {{op.pruefungstext}}
                      </span>
                    </div>
                  </div>
                  <div class="row" style="margin-top:5px;" [hidden]="showOertPrfAuflagen !== op.id">
                    <div *ngFor="let al of op.auflagen; let odd=odd; let even=even;" style="margin-top:5px;" class="col-md-12 col-sm-12" [ngClass]="{ rowRed: al.erledigungsdatum === null, rowgreen: al.erledigungsdatum !== null }">
                      <div class="col-md-1 col-sm-1">
                        <span></span>
                      </div>
                      <div class="col-md-1 col-sm-1">
                        <button title="Öffnen" *ngIf="al.erledigungsdatum === null" (click)="onOpenAuflagenErledigtPopClick(al)" class="btn btn-xs btn-success"><i class="glyphicon glyphicon-ok"></i></button>
                      </div>
                      <div class="col-md-2 col-sm-2">
                        <strong>
                          Termin:
                        </strong>
                        <span>
                          {{al.termin | date}}
                        </span>
                      </div>
                      <div class="col-md-6 col-sm-6">
                        <strong>
                          {{al.beschreibung}}
                        </strong>
                      </div>
                      <div class="col-md-2 col-sm-2">
                        <strong *ngIf="al.erledigungsdatum">
                          Erledigt: {{al.erledigungsdatum | date}}
                        </strong>
                        <strong *ngIf="!al.erledigungsdatum">
                          &nbsp;
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!e.oertPruef.length" class="col-md-12" style="padding:10px;">
                <span>Keine örtliche Prüfungen gefunden.</span>
              </div>
            </div>
          </div>
        </div>
      </dx-accordion>
    </dx-scroll-view>
  </div>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: hideOePopup
        }">
  </dxi-popup-toolbar-item>
</dx-popup>



<dx-popup class="popup"
          [showTitle]="true"
          title="Örtliche Prüfungen anlegen"
          [dragEnabled]="false"
          [height]="'70%'"
          [width]="'70%'"
          style="display: inline-block;"
          [hideOnOutsideClick]="false"
          (onHidden)="onHiddenAuflagenPopup($event)"
          [(visible)]="popupAuflagenVisible">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView
                    *ngIf="!loading"
                    id="scrollview"
                    [scrollByContent]="true"
                    [scrollByThumb]="true"
                    [showScrollbar]="'onHover'"
                    reachBottomText="Updating...">

      <dx-form [colCount]="1" [labelLocation]="'top'" #auflForm [(formData)]="resultOertPrf">
        <dxi-item itemType="group" [colSpan]="1" [colCount]="10">
          <dxi-item itemType="group" [colSpan]="10" [colCount]="12">
            <dxi-item [colSpan]="3" dataField="pruefungstermin" [label]="{text: 'Prüfungstermin'}" editorType="dxDateBox">
              <dxi-validation-rule type="required" message="Prüfungstermin wird benötigt!"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="9" dataField="pruefungstext" [label]="{text: 'Prüfungstext'}">
              <dxi-validation-rule type="required" message="Prüfungstext wird benötigt!"></dxi-validation-rule>
            </dxi-item>
          </dxi-item>
        </dxi-item>
      </dx-form>

      <dx-data-grid style="margin-top:20px;"
                    [dataSource]="resultOertPrf.auflagen"
                    [hoverStateEnabled]="true"
                    [columnAutoWidth]="true"
                    [wordWrapEnabled]="true"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'nextColumn'"
                    [showRowLines]="true"
                    [showBorders]="true">

        <dxo-paging [pageSize]="5"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true"
                   [allowedPageSizes]="[5, 10, 20, 50]"
                   [showInfo]="true"
                   infoText="Seite {0} von {1} Seiten ({2} Datensätze)"
                   [showNavigationButtons]="true">
        </dxo-pager>
        <dxo-editing mode="form"
                     [useIcons]="true"
                     [allowUpdating]="false"
                     [allowAdding]="true">
          <dxo-form [colCount]="1" [labelLocation]="'top'">
            <dxi-item itemType="group" [colCount]="4">
              <dxi-item caption="Fristtermin" dataField="termin" [colSpan]="1" [editorOptions]="{ placeholder: 'Datum', displayFormat: 'dd.MM.yyyy'  }" [validationRules]="[{type: 'required', message: 'Fristtermin wird benötigt!'}]"></dxi-item>
              <dxi-item caption="Beschreibung" dataField="beschreibung" [colSpan]="3" [validationRules]="[{type: 'required', message: 'Beschreibung wird benötigt!'}]"></dxi-item>
            </dxi-item>
          </dxo-form>
        </dxo-editing>


        <dxi-column caption="Fristtermin" dataType="date" dataField="termin" format="dd.MM.yyyy"></dxi-column>
        <dxi-column caption="Beschreibung" dataField="beschreibung"></dxi-column>


      </dx-data-grid>

    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Ok',
            onClick: onClickAuflagenPosPopupOk
        }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: hideOeAuflagenPopup
        }">
  </dxi-popup-toolbar-item>

</dx-popup>


<dx-popup class="popup"
          [showTitle]="true"
          title="Auflage erledigt"
          [dragEnabled]="false"
          [height]="'auto'"
          [width]="'50%'"
          style="display: inline-block;"
          [hideOnOutsideClick]="false"
          (onHidden)="onHiddenAuflagenErledigtPopup($event)"
          [(visible)]="popupAuflagenErledigtVisible">
  <div *dxTemplate="let data of 'content'">

    <dx-form [labelLocation]="'top'" #auflErlForm [(formData)]="selectedAuflageErledigt">
      <dxi-item dataField="erledigungsdatum" [label]="{text: 'Erledigt'}" editorType="dxDateBox">
        <dxi-validation-rule type="required" message="Erledigt wird benötigt!"></dxi-validation-rule>
      </dxi-item>
    </dx-form>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Ok',
            onClick: onClickAuflagenErledigtPopupOk
        }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Schließen',
            onClick: hideOeAuflagenErledigtPopup
        }">
  </dxi-popup-toolbar-item>

</dx-popup>
